exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".up[data-v-78d88732]{width:1050px;margin:0 auto}.el-select .el-input[data-v-78d88732]{width:200px}.el-transfer[data-v-78d88732]{text-align:left}#devmg[data-v-78d88732]{padding-top:20px;width:100%}.el-table[data-v-78d88732]{margin:20px auto}.el-table .warning-row[data-v-78d88732]{background:oldlace}.el-table .success-row[data-v-78d88732]{background:#f0f9eb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78d88732","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/xxxvue/Group_mg.vue
// module id = 255
// module chunks = 0